import * as types from './mutation-types'

export const markAsActive = ({ commit }, id) => {
  commit(types.ACTIVATED_ENTITY, {
    id: id
  })
}

export const showIntroduction = ({ commit }) => {
  commit(types.SHOW_INTRODUCTION)
}



// WEBPACK FOOTER //
// ./src/store/actions.js